var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "footer-icon-stroke",
    d: "M4.71366 17.0705C4.71366 16.815 4.92075 16.6079 5.17621 16.6079H6.85022C7.10568 16.6079 7.31278 16.815 7.31278 17.0705C7.31278 17.3259 7.10568 17.533 6.85022 17.533H5.17621C4.92075 17.533 4.71366 17.3259 4.71366 17.0705Z",
    fill: "#10243E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "footer-icon-stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.20264C0 0.986157 0.986157 0 2.20264 0H9.82379C11.0403 0 12.0264 0.986157 12.0264 2.20264V17.7974C12.0264 19.0138 11.0403 20 9.82379 20H2.20264C0.986157 20 0 19.0138 0 17.7974V2.20264ZM2.20264 1.62996H9.82379C10.1401 1.62996 10.3965 1.88636 10.3965 2.20264V2.81938H1.62996V2.20264C1.62996 1.88636 1.88636 1.62996 2.20264 1.62996ZM1.62996 4.49339V14.0529H10.3965V4.49339H1.62996ZM1.62996 17.7974V15.7269H10.3965V17.7974C10.3965 18.1136 10.1401 18.37 9.82379 18.37H2.20264C1.88636 18.37 1.62996 18.1136 1.62996 17.7974Z",
    fill: "#10243E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.94b3871295d1a80c4b94c6650dcdf739.svg";
export { ForwardRef as ReactComponent };